// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3FNRc","title":"AfterBackImages_title__w2qiG","images":"AfterBackImages_images__D-Jhh"};